export const isChangingLanguage = state => state.language.isChanging;
export const getCurrentLanguage = state => state.language.current;



// WEBPACK FOOTER //
// ./src/store/language/selectors.js